// extracted by mini-css-extract-plugin
export default {"div":"SchoolContent9_div__0W3AW","button":"SchoolContent9_button__eLAd7"};